// @flow
import * as React from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Popover from 'material-ui/Popover';
import { translate } from 'react-i18next';

import Radio from 'common/domain/radio';
import User from 'common/domain/user';
import { openSnackbar } from 'common/modules/ui/actions/uiActions';
import RadioUser from 'statsradio/domain/RadioUser';

import { switchRadio } from '../authentication/session/actions/sessionActions';
import RadioListingItem from './components/RadioListingItem';
import { getRadioUser, getUser } from '../authentication/session/selectors/sessionSelectors';
import { getRadio } from '../authentication/session/reducers/sessionReducer';

const Wrapper = styled.a`
  height: 64px;
  flex: 1;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ theme }) => theme.metrics.smallMargin}px ${({ theme }) => theme.metrics.smallMargin}px;
  border-bottom: solid thin ${({ theme }) => theme.colors.lightGray};
  background-color: ${({ theme }) => theme.colors.secondaryBackground};
  cursor: pointer;
`;

const LogoWrapper = styled.div`
  height: 50px;
  position: relative;
  padding: ${({ theme }) => theme.metrics.tinyMargin}px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
`;

const Logo = styled.img`
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
`;

const Text = styled.div`
  font-size: 20px;
  color: ${({ theme }) => theme.colors.primaryText};
`;

const Icon = styled.i`
  color: ${({ theme }) => theme.colors.primaryText};
`;

const CurrentRadioWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;


const RadioPopover = styled(Popover)`
  width: 350px;
`;

type Props = {
  radio: Radio,
  user: User,
  radioUser?: RadioUser,

  error: string,
  t: any,
  actions: {
    switchRadio: (radio: Object) => void,
    openSnackbar: (type: string, message: string) => void,
  },
};

type State = {
  displayRadios: boolean,
  anchor: React.Node | Object,
};

class CurrentRadioHeader extends React.Component<Props, State> {
  state: State;

  constructor() {
    super();

    this.state = {
      displayRadios: false,
      anchor: {},
    };
  }

  onShowListing = (event) => {
    event.preventDefault();

    this.setState({
      displayRadios: true,
      anchor: event.currentTarget,
    });
  }

  onCloseListing = () => {
    this.setState({ displayRadios: false });
  }

  onRadioSelected = async (selectedRadio: Radio) => {
    const { t, radio } = this.props;
    this.onCloseListing();
    if (selectedRadio.is(radio.callSign)) {
      return;
    }

    await this.props.actions.switchRadio(selectedRadio);
    if (this.props.error) {
      this.props.actions.openSnackbar('error', t('errorWhileChangingStation'));
    }
  }

  render() {
    const { radio, radioUser, user } = this.props;
    if (!radio) {
      return null;
    }

    const { callSign, logo } = radio;
    const { radios } = user;

    return (
      <Wrapper onClick={this.onShowListing}>
        <LogoWrapper className="col-lg-3 col-xs-3">
          <Logo src={logo} />
        </LogoWrapper>
        <CurrentRadioWrapper className="col-lg-8 col-lg-offset-1 col-xs-8 col-xs-offset-1">
          <Text>{callSign}</Text>
          <Icon className="material-icons">arrow_drop_down</Icon>
        </CurrentRadioWrapper>
        <RadioPopover
          open={this.state.displayRadios}
          onRequestClose={this.onCloseListing}
          anchorEl={this.state.anchor}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
          targetOrigin={{ horizontal: 'left', vertical: 'top' }}
        >
          {radios.map(r => <RadioListingItem key={r.callSign} radio={r} user={radioUser} onSelectRadio={this.onRadioSelected} />)}
        </RadioPopover>
      </Wrapper>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getUser(state),
    radioUser: getRadioUser(state),
    radio: getRadio(state),
    error: state.session.error,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ switchRadio, openSnackbar }, dispatch),
  };
}

export default translate('radio')(connect(mapStateToProps, mapDispatchToProps)(CurrentRadioHeader));



// WEBPACK FOOTER //
// ./src/statsradio/modules/radio/CurrentRadioHeader.js